module.exports = __webpack_public_path__ + "static/img/chat-default.d94573b2.png";